<template>
  <component :is="component" v-if="component"/>
</template>

<script>
export default {
  name: "BoardEmptyLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    emptyLayout: '',
  },
  data() {
    return {
      component: null,

    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/board/empty/BoardEmptyDefaultLayout')
        })

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.emptyLayout) {
        return null
      }
      return () => import(`@/template/board/empty/${this.emptyLayout}`)
    },
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>